<div class="app-page-container">

  <div *ngIf="" class="d-flex app-text-success justify-content-center align-items-center">
    <span class="spinner-border spinner-border-sm mr-1"></span>
    Loading Users...
  </div>

  <!-- TEAM LIST -->
  <section *ngIf="!waitOn.init && view === 'defaultView'">
    <div class="d-flex align-items-center justify-content-between flex-wrap">
      <h1 class="mb-3 mr-3" style="line-height: 1">
        Teams
      </h1>
      <button class="btn app-btn-secondary mb-3" type="button" (click)="onSelectView('createTeamForm')"
              [disabled]="waitOn.action">
        Create New
      </button>
    </div>

    <!-- SEARCH -->
    <form [formGroup]="searchForm" class="input-group mb-3">
      <div class="input-group-prepend">
        <button class="btn app-btn-success" style="z-index:0" type="submit" (click)="onSearch(searchForm.value)">
          Search
        </button>
      </div>
      <input class="form-control" formControlName="name" type="text" placeholder="by name" required/>
      <div class="input-group-append">
        <button *ngIf="searchInput !== ''" class="btn app-btn-neutral" type="button" (click)="onClearSearch()">
          Clear
        </button>
      </div>
    </form>

    <article *ngFor="let team of teams; let i = index" class="card mb-3"
             [ngClass]="{ 'd-none': !searchMatch(team) }">
      <app-team-card [team]="team" (edit)="onSelectEditTarget(team)" (delete)="deleteTeam(team)"></app-team-card>
    </article>
  </section>

  <!-- CREATE TEAM -->
  <section *ngIf="view === 'createTeamForm'">
    <div class="d-flex align-items-center justify-content-between flex-wrap">
      <h1 class="mb-3 mr-3" style="line-height: 1">
        Create Team
      </h1>
      <button class="btn app-btn-neutral mb-3" type="button" (click)="onSelectView('defaultView')">
        Cancel
      </button>
    </div>

    <app-team-form [waitOnAction]="waitOn.action" (createTeam)="createTeam($event)">
    </app-team-form>
  </section>

  <!-- EDIT TEAM -->
  <section *ngIf="view === 'editTeamForm'">
    <div class="d-flex align-items-center justify-content-between flex-wrap">
      <div class="d-flex align-items-center mb-3 mr-3">
        <h1 class="mr-3 mb-0" style="line-height: 1">
          Edit Team
        </h1>
        <span class="badge badge-dark">{{'TEAM ID: ' + editTarget.id + ''}}</span>
      </div>
      <button class="btn app-btn-neutral mb-3" type="button" (click)="onCancelEditTarget()">
        Cancel
      </button>
    </div>

    <app-team-form [waitOnAction]="waitOn.action" [editTarget]="editTarget" (editTeam)="editTeam($event)">
    </app-team-form>
  </section>

</div>
